import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faEnvelope, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { User } from 'app/shared/models/Users/user';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { UnlinkLicenceComponent } from '../unlink-licence/unlink-licence.component';
import { UnsubscriptionComponent } from '../unsubscription/unsubscription.component';

@Component({
  selector: 'app-menu-profil',
  templateUrl: './menu-profil.component.html',
  styleUrls: ['./menu-profil.component.scss']
})
export class MenuProfilComponent extends SubscriptionBaseComponent implements OnInit {

  faUnlink = faUnlink;
  faEnvelope = faEnvelope;
  linkLicence;

  menu: any;
  userInfos: User;

  constructor(
    public dialog: MatDialog,
    private authentificationService: AuthenticationService,
    private dataService: DataService,
    private router: Router,
    private titleService: TitleService,
    private ffvService: FfvapiService,
    private userService: UserService,
    private uiService: UiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.checkIfALicence();
    this.initSub();

    this.authentificationService.currentUserSubject.subscribe(user => {
      this.userInfos = user;
    });
    // this.getMenu();
  }

  openDialogUnsubscription(): void {
    const dialogRef = this.dialog.open(UnsubscriptionComponent);

    dialogRef.afterClosed().subscribe(() => { });
  }

  logout(): void {
    this.authentificationService.logout();
    // this.getMenu();
    // this.dataService.isConnect.next(false);
  }

  getShowValue(): void {
    this.dataService.showMenuProfil.next(false);
    this.titleService.title.next('Chang. mote passe');
  }

  link(): void {
    this.linkLicence ?
      this.router.navigate(['/licence']) :
      this.router.navigate(['/link-your-account']);

    if (!this.linkLicence) {
      this.dataService.linkYourAccount.next(true);
    }
  }

  unlinkLicence(): void {
    const dialogRef = this.dialog.open(UnlinkLicenceComponent);
    dialogRef.afterClosed().subscribe(() => { });
  }



  showMyClub(): void {
    this.dataService.showMyClub.next(true);
  }

  showMyWallOfTrophy(): void {
    this.dataService.showTrophy.next(true);
  }

  goToConditions(): void {
    this.router.navigate(['/conditions']);
    this.titleService.title.next('Cond. générales');
  }

  showMySkills(): void {
    this.dataService.showMySkills.next(true);
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private checkIfALicence(): void {
    this.ffvService.checkIfALicence().subscribe(() => {
      this.dataService.userIsLink.next(true);
    }, error => {
      this.dataService.userIsLink.next(false);
      this.uiService.openSnackBar('Licence invalide', '');
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.userIsLink.asObservable().subscribe(isLink => {
          this.linkLicence = isLink;
        })
      );
  }


}
